import React from "react";
import { TreeNodeModel } from "./types";
import { TreeNode } from "./TreeNode";

interface Props {
  data: TreeNodeModel[];
  onSelect: (n: TreeNodeModel) => void;
  onAdd: (parent: TreeNodeModel) => void;
  onDelete: (parent: TreeNodeModel) => void;
  readonly?: boolean
  isClientExistent?: boolean
  isViewer?: boolean
}

export const Tree: React.FC<Props> = ({ data, onSelect, onAdd, onDelete, readonly, isClientExistent, isViewer }) => (
  <>
    {data.map(node => (
      <TreeNode
        key={node.id}
        node={node}
        onSelect={onSelect}
        onAdd={onAdd}
        onDelete={onDelete}
        readonly={readonly}
        isClientExistent={isClientExistent}
        isViewer={isViewer}
      />
    ))}
  </>
);
